import { ILocation } from '../../../api/locations';
import { FDealType, FOfferType } from '../../../utils/category';
import { getRegionId, isNewbuildingsRegion } from '../../../utils/geo';
import { ESuburbanOfferFilter } from '../../../json_query';
import { ESuburbanOfferFilter as ESuburbanOfferFilterV2 } from '../../../repositories/geo-suggest/v2/suggest';

export type TGeoSuggestItemType = 1 | 2 | 3 | 4 | 5;
export const GeoSuggestItemType = {
  Address: 1 as 1,
  Newbuilding: 2 as 2,
  BSCenter: 3 as 3,
  Highway: 4 as 4,
  Railway: 5 as 5,
};

export const isNewbuildingsAvailable = (
  dealType: FDealType,
  offerType: FOfferType,
  currentLocation: ILocation | 'moscow_mo' | 'spb_lo',
) => dealType & FDealType.Any && offerType & FOfferType.Urban && isNewbuildingsRegion(getRegionId(currentLocation));

export const removeCountryName = (value: string) => value.replace(/(^Россия, )|(, Россия$)/i, '');

export const SUBURBAN_OFFER_FILTER = {
  [ESuburbanOfferFilter.Any]: ESuburbanOfferFilterV2.All,
  [ESuburbanOfferFilter.Builder]: ESuburbanOfferFilterV2.Builder,
  [ESuburbanOfferFilter.Individual]: ESuburbanOfferFilterV2.Individual,
};

export const getSuburbanOfferFilterValue = (suburbanOfferFilterValue: ESuburbanOfferFilter | undefined) => {
  if (suburbanOfferFilterValue == null) {
    return suburbanOfferFilterValue;
  }

  return SUBURBAN_OFFER_FILTER[suburbanOfferFilterValue];
};
